export default __webpack_public_path__ + "static/media/WorldOfDinosaurs.ddd41354.PNG";